import React, { useState } from 'react';
import { ZoomIn, X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      url: 'https://static.wixstatic.com/media/5924bc_148da214afbf4252918ecb719a65d375~mv2.jpg/v1/fill/w_800,h_521,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202025-12-13%20at%2014_03_edited.jpg',
      title: 'Side Ramp / Loading',
      description: 'Lightweight barn door style ramp with extra thick rubber'
    },
    {
      url: 'https://static.wixstatic.com/media/5924bc_588e918cf7e5495ebbdd1a760195a68d~mv2.jpg/v1/fill/w_444,h_606,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202025-12-13%20at%2014_03_edited.jpg',
      title: 'Front View',
      description: 'Renault Master 3.5-ton professional horsebox'
    },
    {
      url: 'https://static.wixstatic.com/media/5924bc_cc9593d1d7a54e7bbeb5be5cef6c7ae5~mv2.jpeg/v1/fit/w_1440,h_612,q_90,enc_avif,quality_auto/5924bc_cc9593d1d7a54e7bbeb5be5cef6c7ae5~mv2.jpeg',
      title: 'Side View',
      description: 'Built by Foxy Horseboxes to exceptional standards'
    },
    {
      url: 'https://static.wixstatic.com/media/5924bc_54df50bde30c475eb1c33c2297ca57d6~mv2.jpeg/v1/fit/w_1440,h_612,q_90,enc_avif,quality_auto/5924bc_54df50bde30c475eb1c33c2297ca57d6~mv2.jpeg',
      title: 'Barn Door View',
      description: 'Spacious and comfortable interior for your horse'
    }
  ];

  return (
    <section id="gallery" className="py-20 lg:py-28 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-['Playfair_Display']">
            View Our <span className="text-[#2d5f3f]">Horsebox</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Take a closer look at our newly built, state-of-the-art horsebox. Click any image to enlarge.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(image)}
            >
              <div className="aspect-[4/3] overflow-hidden bg-gray-200">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-xl font-bold mb-2">{image.title}</h3>
                  <p className="text-sm text-white/90">{image.description}</p>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <ZoomIn className="w-5 h-5 text-white" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            View all horsebox images in detail
          </p>
          <a
            href="/gallery"
            className="inline-flex items-center px-6 py-3 bg-[#2d5f3f] text-white rounded-lg hover:bg-[#1e4029] transition-colors duration-300 font-semibold"
          >
            Take a Detailed Look
          </a>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 flex items-center justify-center transition-colors duration-300 group"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          
          <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg shadow-2xl"
            />
            <div className="mt-6 text-center text-white">
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              <p className="text-white/80">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;